import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../redux/actions/menuActions";
import Menu from "./Menu.basepdc";

import AuthRender from "../../containers/AuthRender";
import { SERVICES } from "../../configs/constants";
import { Redirect } from "react-router";
class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("basepdc");
    this.props.setMenuLeftIndex("home");
    this.props.setMenuLeftItemIndex("");
    this.props.setMenuLeftContent(Menu);
  }
  render() {
    return (
      <div className="p-landing">
        <AuthRender service={SERVICES.PDC}>
          <Redirect to="/basepdc/listpdcs" />
        </AuthRender>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/basepdc/Home.basepdc.js